import type { MutableRefObject } from 'react';
import { useEffect } from 'react';
import { useUrlHashContext } from '@contexts/UrlHash';

export const getOldFormatHash = (headerText, headerId) => {
  // 1. When hash in DPv1 format, for example: '1.15.1-1july,2022' or 'configureyourproduct,pages,andbuilds'
  // let oldFormatHash = refAnchor.current?.textContent
  let oldFormatHash = headerText
    ?.toLocaleLowerCase()
    .replaceAll(' ', '')
    .replaceAll('(', '_')
    .replaceAll(')', '_')
    .replaceAll('’', "'");

  // 1.1 When we have repeated headers: DPv2 'cons-1', DPv1 'cons_1'
  const repeatingTitleRegEx = /(.*?)-([0-9])$/;
  // const match = refAnchor.current.id.match(repeatingTitleRegEx);
  const match = headerId.match(repeatingTitleRegEx);
  if (match?.length) {
    oldFormatHash += `_${match[2]}`;
  }
  return oldFormatHash;
};

export const useScrollIntoView = (refAnchor: MutableRefObject<HTMLElement | undefined>, activeAnchorId: string) => {
  const { hash, isHashScrolling, setHashScrolling } = useUrlHashContext();
  const decodedHash = decodeURIComponent(hash);

  useEffect(() => {
    if (decodedHash && refAnchor.current) {
      const oldFormatHash = getOldFormatHash(refAnchor.current?.textContent, refAnchor.current?.id);
      // 2. When hash in DPv2 format, for example: adding-roles
      const newFormatHash = refAnchor.current.id;

      if (refAnchor.current && (decodedHash === newFormatHash || decodedHash === oldFormatHash)) {
        setHashScrolling(true);
        refAnchor.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  }, [decodedHash, refAnchor.current]);

  useEffect(() => {
    if (decodedHash && refAnchor.current) {
      const oldFormatHash = getOldFormatHash(refAnchor.current?.textContent, refAnchor.current.id);
      /*
       check for:
       current hash (old format DPv1 or new one),
       scroll position (current active header is desired)
      */
      if (
        (activeAnchorId === decodedHash || decodedHash === oldFormatHash) &&
        activeAnchorId === refAnchor.current?.id
      ) {
        const t = setTimeout(() => {
          refAnchor.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 1000);
        return () => clearTimeout(t);
      }
    }
    return () => {};
  }, [activeAnchorId, decodedHash, isHashScrolling, refAnchor]);
};
